export const kidsFootwears = [
    {   
        id: 0,
        name: 'Kids rubber',
        price: 9.99,
        image: './asset/kids-footwear.png'
    },  
    {
        id: 1,
        name: 'Black boots',
        price: 9.99,
        image: './asset/kids-footwear1.png'
    },
    {
        id: 2,
        name: 'Pink boots',
        price: 9.99,
        image: './asset/kids-footwear2.png'
    },
    {
        id: 3,
        name: 'Closed sandals',
        price: 6.99,
        image: './asset/kids-footwear3.png'
    },
    {
        id: 4,
        name: 'White sandal',
        price: 6.99,
        image: './asset/kids-footwear4.png'
    },
    {
        id: 5,
        name: 'Blue slipper',
        price: 4.99,
        image: './asset/kids-footwear5.png'
    },
    {
        id: 6,
        name: 'Grey slipper',
        price: 4.99,
        image: './asset/kids-footwear6.png'
    }
]
